import { State } from '../store';

export const requestsSelector = (state: State) => state.requests;